export const WIZARD_BASE_TRAD_KEY = `Wizard`;
export const WIZARD_PANEL_TRAD_KEY = `${WIZARD_BASE_TRAD_KEY}.Panel`;
export const WIZARD_RESULTS_TRAD_KEY = `${WIZARD_BASE_TRAD_KEY}.Results`;
export const WIZARD_LIST_TRAD_KEY = `${WIZARD_BASE_TRAD_KEY}.BasketList`;
export const WIZARD_UI_TRAD_KEY = `${WIZARD_BASE_TRAD_KEY}.UI`;

export const WIZARD_BASKET_STATUS_TRAD_KEY = `${WIZARD_BASE_TRAD_KEY}.Results.UI.Basket.Status`;

export const RESET_DIALOG_TRAD_KEY = `${WIZARD_PANEL_TRAD_KEY}.UI.ResetBasket.Dialog`;
export const DELETE_DIALOG_TRAD_KEY = `${WIZARD_PANEL_TRAD_KEY}.UI.DeleteBasket.Dialog`;

export const DUPLICATE_DIALOG_TRAD_KEY = `${WIZARD_UI_TRAD_KEY}.Dialog.Duplicate`;

export const WIZARD_PANEL_LABELS_KEY = `${WIZARD_PANEL_TRAD_KEY}.UI.Labels`;
export const WIZARD_PANEL_TOOLTIPS_KEY = `${WIZARD_PANEL_TRAD_KEY}.UI.Tooltips`;
